import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useBreadcrumb } from "../../../hooks/navigation/useBreadcrumb";
import { FontsList } from "../../../components/libraries/fonts/FontsList";
import { FontUploadButton } from "../../../components/libraries/fonts/FontUploadButton";

export const Alphabets: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumb = useBreadcrumb("libraries");

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("libraries.fonts.embroidery.title")}
          breadcrumb={breadcrumb}
          extra={<FontUploadButton service="embroidery" />}
        />
      }
    >
      <FontsList />
    </MainContentArea>
  );
};
